import { Host } from "@models/host.model";
import { BaseConverter } from "./base.converter";
import { HostDto } from "@dtos/host.dto";

export class hostConverter extends BaseConverter<Host, HostDto>{
    modelToDto(model: Host): HostDto {
        return new HostDto(
            model.id,
            model.identificationCode,
            model.email,
            model.name,
            model.surname,
            model.mobileNumber,
            model.registrationDate?.toISOString(),
            model.lastUpdate?.toISOString(),
            model.active,
            model.locale
        )
    }

    dtoToModel(dto: HostDto): Host {
        return new Host(
            dto.id,
            dto.identificationCode,
            dto.email,
            dto.name,
            dto.surname,
            dto.mobileNumber,
            dto.registrationDate? new Date(dto.registrationDate) : undefined,
            dto.lastUpdate? new Date(dto.lastUpdate) : undefined,
            dto.active,
            dto.locale
        )
    }
}